import React, { useState, Fragment, useContext } from "react";
import Spinner from "../../assets/images/spinner.gif";
import Popup from "../Modal/Popup";
import { UserContext } from "../../context/userContext";
import Axios from "../../axios";
import Reload from "../../assets/images/reloadApiWhite.svg";

const CreateNewDP = (props) => {
  const [newCardTitle, setNewCardTitle] = useState("");
  const [newCardDescription, setNewCardDescription] = useState("");
  const { userID, sessionID, flimpID } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const generateNewCard = () => {
    setLoading(true);
    const data = {
      u: userID,
      sn: sessionID,
      title: newCardTitle,
      t: "N",
      desc: newCardDescription,
    };
    Axios.MicrositeService.POST_NEW_MICROSITE(data)
      .then((response) => {
        if (response.data.statusCode === "success") {
          let flimpID = response.data.body.flimp_id;
          setLoading(false);
          setTimeout(() => {
            let url = window.location.href;
            url = new URL(url);
            url.searchParams.set("f", flimpID);
            window.location.href = url.href;
          }, 1000);
          setSaved(true);
        } else if (response.data.statusCode !== "success") {
          setLoading(false);
          setCreateNewError("Error creating new microsite limit exceeded");
        }
      })
      .catch((err) => {
        setLoading(false);
        setCreateNewError("Error creating new microsite limit exceeded");
      });
  };
  return (
    <Popup
      width="700"
      header="Create new microsite"
      // save={props.generateNewCard}
      btnLabel="Create"
      closePopup={props.cancelNewCard}
      close={props.cancelNewCard}
    >
      <div className="createNewCardSec modalContentWrapper">
        <div className={"window " + (props.validation ? "validation" : null)}>
          {props.limitExceed ? (
            <label>
              You have exceeded the maximum number of allotted microsites.
            </label>
          ) : (
            <Fragment>
              <label>Microsite Title</label>
              {props.newCardTitle ? (
                <small style={{ color: "red" }}>
                  Please add valid Microsite title
                </small>
              ) : null}
              <input onChange={props.setCardTitle} type="text" />

              <label>Brief Description</label>
              {props.newCardDscr ? (
                <small style={{ color: "red" }}>
                  Please add valid Microsite description
                </small>
              ) : null}
              <textarea onChange={props.setCardDescription} />
            </Fragment>
          )}
          {props.limitExceed ? (
            <button
              style={{ marginLeft: "0" }}
              onClick={props.cancelNewCard}
              className="cancelBtn"
            >
              Cancel
            </button>
          ) : (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={generateNewCard}
                className="createBtn boxShadowOnHover"
              >
                {loading ? (
                  <div className="loading" />
                ) : saved ? (
                  <div className="wrapperSaved">
                    <svg
                      version="1.1"
                      id="Layer_1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 98.5 98.5"
                      enableBackground="new 0 0 98.5 98.5"
                    >
                      <path
                        className="checkmark"
                        fill="none"
                        strokeWidth="8"
                        strokeMiterlimit="10"
                        d="M81.7,17.8C73.5,9.3,62,4,49.2,4
	                    C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
                      />
                    </svg>
                  </div>
                ) : (
                  "Create"
                )}
              </button>
              <button
                onClick={props.cancelNewCard}
                className="cancelBtn boxShadowOnHover"
              >
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    </Popup>
  );
};
export default CreateNewDP;
